import React, { Component, Fragment, useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import Swal from 'sweetalert2';
import { resetPasswordWithToken } from '../../../Services/LoginServices';
import { utils } from '../../../helpers/utils';
import { useHistory, useLocation } from "react-router-dom";
import { userRole } from '../../../Constants/userRoles';
import jwtDecode from 'jwt-decode';
import { User } from '../../../Types/User';

export type ForgetPasswordFormValues = {
    [key: string]: any;
}

export type ForgetPasswordFormRef = {
    [key: string]: React.RefObject<HTMLElement | null>
}

export type ForgetPasswordFormErrors = {
    [key: string]: string;
}

export type ForgetPasswordFormTouched = {
    [key: string]: boolean;
}

export type ValidtionFunctions = {
    [key: string]: Function;
}

export interface LocationState {
    from: {
      pathname: string;
    };
  }
  


export function useResetPasswordForm() {

    let history = useHistory();
    let location = useLocation<LocationState>();
    
    let { from } = location.state || { from: { pathname: "/" } };
    const defaultValues: ForgetPasswordFormValues = {
        password: '',
        confirmPassword:'',
    };
    const validations = {

        password: async function (values: ForgetPasswordFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!values.password) {
                        error = 'Please enter your new password';
                    }
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        confirmPassword: async function (values: ForgetPasswordFormValues) {
            // Do validation here
            // two promises, one for local, one for async, usually serverside.
            let error: string | null = null;
            let promises = [
                new Promise((resolve, reject) => {
                    // local validation logic here.
                    if (!(values.password === values.confirmPassword)) {
                        error = 'Two password does not match!';
                    }
                    if (error != null) {
                        reject(error);
                    } else {
                        resolve(null);
                    }
                }),
                new Promise(
                    (resolve, reject) => {
                        // do server validation logic here.
                        resolve(null);
                    }
                ),
            ];
            let result = await Promise.all(promises);
            return result;
        },
        

    }

    let isSubmit = false;
    const debounceTime = 250;
    const ref = useRef(initRefs(defaultValues));
    const [values, setValues] = useState<ForgetPasswordFormValues>(defaultValues);
    const [errors, setErrors] = useState<ForgetPasswordFormErrors>({});
    const [touched, setTouched] = useState<ForgetPasswordFormTouched>({});
    const debouncedValidateForm = _.debounce(validateForm, debounceTime);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string|null>(null);

    let validationCount = 0;
    let validationTotal = 1;

    function initRefs(viewModel: ForgetPasswordFormValues) {
        if (viewModel == null) {
            return {};
        } else {
            let result: ForgetPasswordFormRef = {};
            Object.keys(viewModel).forEach((key) => {
                result[key] = React.createRef<HTMLElement | null>();
            });
            return result;
        }
    }

    function registerRef(ref: HTMLElement | null) {
        console.log(ref);
        console.log(typeof ref);
    }

    function touchAll() {
        let keys = Object.keys(defaultValues);
        keys.forEach((key) => {
            touched[key] = true;
        });
        setTouched(touched);
    }

    function counterHit(currentError: ForgetPasswordFormErrors) {
        validationCount += 1;
        // we did not handle timeout problem, but it will in future
        if (validationCount === validationTotal) {
            validationCount = 0;
            if (_.isEmpty(currentError)) {
                setIsValid(true);
                if (isSubmit === true) {
                    isSubmit = false;
                    setIsLoading(true);
                    saveData({ ...values });
                } else {
                    setIsLoading(false);
                }
            } else {
                if (isSubmit === true) {
                    isSubmit = false;
                }
                if (isValid !== false) {
                    setIsValid(false);
                }
                setIsLoading(false);
            }


        }
    }

    function saveData(viewModel: ForgetPasswordFormValues) {
        setIsSubmitting(true);
        setIsLoading(true);
        setErrorMessage(null);
        let newData = _.cloneDeep(viewModel);
        delete newData.confirmPassword;
        let parms = parseUserIdAndToken();
        if(parms == null){
            setIsValid(false);
            setErrorMessage('Invalid link, or this reset link has expired.');
        }
        else {
            newData.userId = parms.uid;
            newData.token = parms.token;
        }
        newData.newPassword = newData.password;
        delete newData.password;
        //console.log(parms);
        resetPasswordWithToken(newData, false).then((res) => {
            setIsLoading(false);
            setIsSubmitting(false);
            if (res && res.status === 200) {                
                console.log(res);
                if(res.data && res.data.succeeded === false){
                    setIsValid(false);
                    setErrorMessage(res.data.reason);

                }else if(res.data && res.data.succeeded === true){
                    toastSuccessMessage('New password set!');
                    setTimeout(()=>{
                        history.push('/login');
                    },500);
                }

            } else if (res && res.status === 401) {
                setIsValid(false);
                setErrorMessage('Invalid link.');
            }
            else {
                Swal.fire(
                    {
                        icon: 'error',
                        title: 'Error While Processing',
                        text: `${res && res.data ? res.data : "No detail reason available."}`,
                        showConfirmButton: true,
                        confirmButtonText: "OK",
                        confirmButtonColor: '#1678c2'
                    }
                ).then(() => {
                });
            }
        }, (error) => {
            setIsLoading(false);
            setIsSubmitting(false);
            if (error.response && error.response.data && error.response.status === 500) {
                let footer = '';
                Swal.fire(
                    {
                        icon: 'error',
                        title: 'Error While Processing',
                        text: `${error.response.data ? error.response.data : "No detail reason available"}`,
                        showConfirmButton: true,
                        footer: footer,
                        confirmButtonText: "OK",
                    }
                ).then(() => {
                });
            }
        });
    }

    function resetForm() {
        Object.keys(defaultValues).forEach((key, index) => {
            let temp = ref.current[key].current;
            if (temp != null) {
                // not implemented yet
            }
        });
        setValues(defaultValues);
        setIsLoading(false);
        setTouched({});
        setErrors({});
    }

    async function handleSubmit() {
        touchAll();
        setIsLoading(true);
        validateForm(values, validations, null);
        isSubmit = true;
    }

    function validateForm(values: ForgetPasswordFormValues, validations: ValidtionFunctions, fieldName: string | null = null) {
        let newErrors: ForgetPasswordFormErrors = {};
        setIsLoading(true);
        if (fieldName != null) {
            // only validate the changing field.Keep current errors info
            newErrors = errors;
            validationTotal = 1;
            validationCount = 0;
            validations[fieldName](values).then(() => {
                delete newErrors[fieldName];
                setErrors(newErrors);
                counterHit(newErrors);
            }, (error: string) => {
                newErrors[fieldName] = error;
                setErrors(newErrors);
                counterHit(newErrors);
            });
        } else {
            // if this validate is not trigered by input control change, validate all.
            let keys = Object.keys(defaultValues);
            validationTotal = keys.length > 0 ? keys.length : 0;
            validationCount = 0;
            keys.forEach((key) => {
                validations[key](values).then(() => {
                    delete newErrors[key];
                    setErrors(newErrors);
                    counterHit(newErrors);
                }, (error: string) => {
                    newErrors[key] = error;
                    setErrors(newErrors);
                    counterHit(newErrors);
                });
            });

        }

    }


    function handleBlur(fieldName: string) {
        if(errorMessage != null){
            setErrorMessage(null);
        }
        setTimeout(() => {
            setTouched((prevValue) => {
                return {
                    ...prevValue,
                    [fieldName]: true,
                }
            });
            validateForm(values, validations, null);
        }, 250);
    }

    function handleChange(newValue: any, fieldName: string, fieldOnly = true) {
        if(errorMessage != null){
            setErrorMessage(null);
        }
        values[fieldName] = newValue;
        setValues(values);
        if (!(touched[fieldName] != null)) {
            setTouched({ ...touched, [fieldName]: true });
        }
        debouncedValidateForm(values, validations, fieldOnly ? fieldName : null);
    }

    function isValidEmail(testTarget: string) {
        let myReg = /\b[\w\.-]+@[\w\.-]+\.\w{2,4}\b/gi;
        return myReg.test(testTarget);
    }

    function toastSuccessMessage(message: string) {
        Swal.fire({
            icon: 'success',
            position: 'top-end',
            title: 'Success',
            text: message,
            timer: 10000,
            toast: true,
            timerProgressBar: true,
            showConfirmButton: false,
            showCancelButton: false,
        })
    }

    function parseUserIdAndToken(){
        let result = null;
        let currSearch = window.location.search;
        if(!currSearch){
            return result;
        }
        console.log(window.location.search);

        currSearch = currSearch.replaceAll('?','');
        let parts = currSearch.split('uid=');
        let uid = parts[1];
        parts = currSearch.split('token=');
        let token = parts[1];
        
        if(!(uid && token)){
            return result;
        }
        if(isNaN(parseInt(uid))){
            return result;
        }
        return {
            uid: parseInt(uid), token
        }
        
    }

    return [values, errors, touched, isLoading, isSubmitting, isValid,errorMessage, registerRef, handleChange, handleBlur, handleSubmit] as const;

}
